import BusSystemApi from './_busSystemApi';

class GettingStartedApi extends BusSystemApi {
  constructor() {
    super();
  }
  apiName = 'BusinessSystem';
  controllerName = 'GettingStarteds';

  /**
   * Lấy trạng thái hoàn thành getting started
   * vqphong - 23/07/2025
   */
  getCompletionStatus(tenantId) {
    const request = {
      url: this.getAPIUrl() + `/completion-status?tenantId=${tenantId}`,
    };

    return this.getAsync(request);
  }

  /**
   * hoàn thành thiết lập (type nâng cao)
   * vqphong - 28/07/2025
   * Case mua thêm isAdditionalPurchase
   */
  getStarted(step, isAdditionalPurchase) {
    const request = {
      url: this.getAPIUrl() + '/getting-started',
      params: {
        step,
        isAdditionalPurchase
      },
    };

    return this.postAsync(request);
  }



  // [htthoa - 2026-06-08] Thêm mới: lấy danh sách subapp theo budget_code của user hiện tại với status = AlreadyAllocated
  getSubAppByBudgetCodes() {
    const request = {
      url: this.getAPIUrl() + '/sub-app-by-budget-codes',
    };

    return this.getAsync(request);
  }

  // [htthoa - 2026-06-08] Thêm mới: kiểm tra nếu user có đúng 1 budget_code và tenant tương ứng là xã
  isCommuneByBudgetCode() {
    const request = {
      url: this.getAPIUrl() + '/is-commune-by-budget-code',
    };

    return this.getAsync(request);
  }

  // [htthoa - 2026-09-10] Thêm mới: lấy danh sách dữ liệu kế toán Mimosa cho luồng getting started upgrade
  getAccountingDatabases(appCode) {
    const request = {
      url: this.getAPIUrl() + `/accounting-databases?appCode=${appCode}`,
    };

    return this.getAsync(request);
  }

   syncUserRoles() {
    const request = {
      url: this.getAPIUrl() + `/users`,
    };
    return this.postAsync(request);
  }
}

export default new GettingStartedApi();
